<template>
  <v-row class="mb-4">
    <v-col>
      <!-- don't v-for because focus will break -->
      <v-text-field
        class="centered-input"
        maxlength="1"
        ref="input0"
        :value="code.input0"
        :rules="[requiredNumberCheck]"
        @input="(val) => updateCode(0, val)"
        @keyup="toNextInput(1)"
        hide-details
        outlined
        required
        inputmode="numeric"
        autocomplete="one-time-code"
      />
    </v-col>
    <v-col>
      <v-text-field
        class="centered-input"
        maxlength="1"
        ref="input1"
        :rules="[requiredNumberCheck]"
        :value="code.input1"
        @input="(val) => updateCode(1, val)"
        @keyup="toNextInput(2)"
        hide-details
        outlined
        required
        inputmode="numeric"
      />
    </v-col>
    <v-col>
      <v-text-field
        class="centered-input"
        maxlength="1"
        ref="input2"
        :rules="[requiredNumberCheck]"
        :value="code.input2"
        @input="(val) => updateCode(2, val)"
        @keyup="toNextInput(3)"
        hide-details
        outlined
        required
        inputmode="numeric"
      />
    </v-col>
    <v-col>
      <v-text-field
        class="centered-input"
        maxlength="1"
        ref="input3"
        :rules="[requiredNumberCheck]"
        :value="code.input3"
        @input="(val) => updateCode(3, val)"
        @keyup="toNextInput(0)"
        hide-details
        outlined
        required
        inputmode="numeric"
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "SMSInput",
  data() {
    return {
      abortController: null,
    };
  },
  methods: {
    focusInput(index) {
      this.$refs[`input${index}`].focus();
    },
    reFocusIfNoCodeValues(code) {
      Object.values(code).every((input) => !input) && this.focusInput(0);
    },
    requiredNumberCheck(value) {
      return !!value && !isNaN(value);
    },
    async setupWebOTP() {
      if ('OTPCredential' in window) {
        this.abortController = new AbortController();

        try {
          const otp = await navigator.credentials.get({
            otp: { transport: ['sms'] },
            signal: this.abortController.signal,
          });

          if (otp && otp.code) {
            // split the code and distribute to inputs
            const digits = otp.code.split('').slice(0, 4);
            digits.forEach((digit, index) => {
              this.updateCode(index, digit);
            });

            // focus the last input or first empty one
            const lastFilledIndex = digits.length - 1;
            this.focusInput(Math.min(lastFilledIndex, 3));
          }
        } catch (err) {
          console.warn('WebOTP error:', err);
        }
      } else {
        console.warn('WebOTP API is not supported on this browser');
      }
    },
    toNextInput(input) {
      input && this.code[`input${input - 1}`] && this.focusInput(input);
    },
  },
  beforeDestroy() {
    if (this.abortController) {
      this.abortController.abort();
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.focusInput(0);
      this.setupWebOTP();
    });
  },
  props: {
    code: Object,
    updateCode: Function,
  },
  watch: {
    code: {
      handler(code) {
        this.reFocusIfNoCodeValues(code);
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.centered-input >>> input {
  text-align: center;
}
.v-text-field >>> input {
  /*font-size: 1.75rem;*/
  font-size: 1.5rem;
}
</style>
